import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Box, Container, Grid } from '@material-ui/core';
import { connect } from 'react-redux';

import { useStyles } from './Style';
import Header from './Header';
import Menu from './MenuMain';
import Footer from './Footer';
import BreadcrumbNavigation from './Breadcrumb';

const Wrapper = (props) => {
    const { children, classes, drawerOpen } = props;
    
    return (
        <div className={classes.root}>
            {/* Menu Lateral */}
            <Menu />
            
            {/* Header + Conteúdo Principal */}
            <div className={classes.content}>
                {/* Header - position absolute */}
                <Header />
                
                {/* 🆕 Spacer para reservar espaço do AppBar */}
                <div className={classes.appBarSpacer} />
                
                {/* Breadcrumb + Conteúdo */}
                <div className={classes.mainContent}>
                    {/* 🆕 Breadcrumb */}
                    <BreadcrumbNavigation />
                    
                    {/* Conteúdo das Páginas */}
                    <div className={classes.container}>
                        {children}
                    </div>
                    
                    {/* Footer */}
                    <Footer />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    drawerOpen: state.menu.drawerOpen,
});

export default connect(mapStateToProps)(withStyles(useStyles)(Wrapper));